import React from 'react'

const Clock = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill={props.color ? props.color : '#FFFFFF'}
         className={props.className ? props.className : ''} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 14.4C4.4712 14.4 1.6 11.5288 1.6 8C1.6 4.4712 4.4712 1.6 8 1.6C11.5288 1.6 14.4 4.4712 14.4 8C14.4 11.5288 11.5288 14.4 8 14.4Z"
        />
        <path d="M8.8 4H7.2V8.8H12V7.2H8.8V4Z"/>
    </svg>
)

export default Clock
